import { render, staticRenderFns } from "./TenantComponent.vue?vue&type=template&id=a5f08604&scoped=true&"
import script from "./TenantComponent.vue?vue&type=script&lang=js&"
export * from "./TenantComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f08604",
  null
  
)

export default component.exports